import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { colors } from 'kangarootime-ui';
import moment from 'moment';
import './TimecardsTable.css';

const ClocksTableCell = ({
  timecards,
  direction,
  as,
  setEditsToTimecard,
  clockEditsById,
  ...props
}) => {
  const formatTimeAsSpan = useCallback(date => {
    return date ? moment(date).format('h:mm A') : '';
  }, []);

  const formatTimeForTimeInput = useCallback(date => {
    return date ? moment(date).format('HH:mm') : '';
  }, []);

  const handleInputChange = useCallback((event, clockDirection, timecard) => {
    const timeProperty = clockDirection === 'in' ? 'start' : 'end';
    const { target: { value } } = event;
    const [hour, minute] = value.split(':');

    const copy = {
      ...timecard,
      [timeProperty]: moment(timecard[timeProperty]).clone().hour(hour).minute(minute).toISOString()
    };

    setEditsToTimecard(
      timecard.timecard_id,
      copy.start,
      copy.end
    );
  }, []);

  const clockTimes = useCallback(direction => timecards.map(timecard => {
    const tCard = clockEditsById && clockEditsById[timecard.timecard_id] ? clockEditsById[timecard.timecard_id] : timecard;
    const time = direction === 'in' ? tCard.start : tCard.end;
    const timeProperty = direction === 'in' ? 'start' : 'end';
    const hasEdits = clockEditsById[timecard.timecard_id] !== undefined;

    return (/input/.test(as)
      ? <input
        className='kt-ui-text-input'
        type='time'
        key={`clock-${direction}-${timecard.timecard_id}`}
        value={formatTimeForTimeInput(time)}
        onChange={event => handleInputChange(event, direction, tCard)}
        style={{
          border: hasEdits && timecard[timeProperty] !== tCard[timeProperty] ? `2px solid ${colors.brand_3}` : 'transparent'
        }}
      />
      : <span
        key={`clock-in-${time}`}
        className='timecards-table-employee-row-text'
      >
        {formatTimeAsSpan(time)}
      </span>
    );
  }), [timecards, clockEditsById]);

  return (
    <td>
      {clockTimes(direction)}
    </td>
  );
};

ClocksTableCell.propTypes = {
  timecards: PropTypes.arrayOf(PropTypes.object),
  direction: PropTypes.oneOf(['in', 'out']),
  as: PropTypes.oneOf(['span', 'input']),
  setEditsToTimecard: PropTypes.func,
  clockEditsById: PropTypes.object
};

ClocksTableCell.defaultProps = {
  timecards: [],
  as: 'span',
  clockEditsById: {}
};

export default ClocksTableCell;
